import { ChangeDetectionStrategy, Component, inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '../../utilities/tabs/tabs-module-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiOnboardingBuilderHelperService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-builder-helper.service';
import { FiCustomerDataService } from '@fi-app/shared/fi-shared-services/fi-customer-data.service';
import { ObjectTypes } from '@fi-shared/types';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiOnboardingNavigationService } from '@fi-app/fi-onboarding/fi-onboarding-navigation.service';
import { FiOnboardingReportHelperService } from '../fi-onboarding-report/services/fi-onboarding-report-helper.service';

@Component({
    selector: 'fi-onboarding-navigation-tabs',
    templateUrl: './fi-onboarding-navigation-tabs.component.html',
    styleUrl: './fi-onboarding-navigation-tabs.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-navigation-tabs' },
    standalone: false,
})
export class FiOnboardingNavigationTabsComponent extends TabsModuleBase implements OnInit {
    private fiOnboardingNavigationService: FiOnboardingNavigationService = inject(FiOnboardingNavigationService);
    private fiOnboardingBuilderHelperService: FiOnboardingBuilderHelperService = inject(
        FiOnboardingBuilderHelperService,
    );
    private customerDataService: FiCustomerDataService = inject(FiCustomerDataService);
    private pageTitleService = inject(PageTitleService);
    private fiOnboardingReportHelperService = inject(FiOnboardingReportHelperService);

    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnInit(): void {
        this.pageTitleService.setTitleByObjectType(ObjectTypes.Onboarding, false);
        this.tabs = this.fiOnboardingNavigationService.getOnboardingTabs();
        super.updateSelectedTabFromState();
    }

    protected openAddDialog(): void {
        const sref = this.getAddSref();
        if (sref === FiStateNames.Onboarding.Add) {
            if (this.customerDataService.isSynchronizedOnboardingEnabled()) {
                this.fiOnboardingBuilderHelperService.openAddOnboardingDialog();
                return;
            }
            this.stateService.go(FiStateNames.Onboarding.Add);
        }
    }

    protected isOnboardingTabSelected(): boolean {
        return this.stateService.current.name === FiStateNames.Onboarding.List;
    }

    protected isReportState(): boolean {
        return this.stateService.current.name === FiStateNames.Onboarding.Report.Dashboard;
    }

    protected triggerOpenAddReportWidgetDialog(): void {
        this.fiOnboardingReportHelperService.triggerOpenAddReportWidgetDialog();
    }
}
